import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';

import * as Colors from 'src/theme/colors';

const useStyles = makeStyles((theme) =>
  createStyles({
    iconWrapper: {
      backgroundColor: Colors.HoverNonBorderBackground,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: theme.shape.borderRadius,
      '&>svg': {
        color: Colors.GraySmall,
      },
    },
  }),
);

type IconTileProps = {
  icon?: React.ReactNode;
  width?: number;
  height?: number;
  mb?: number;
  className?: string;
};

const IconTile = (props: IconTileProps) => {
  const classes = useStyles();
  const {
    icon,
    width = 40,
    height = 40,
    mb = 1.5,
    className,
    ...others
  } = props;
  const marginBottom = mb * 8; // Convert MUI spacing to px
  return (
    <div
      className={`${classes.iconWrapper} ${className || ''}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        marginBottom: `${marginBottom}px`,
      }}
      {...others}
    >
      {icon}
    </div>
  );
};

export default IconTile;
